import { merge, clone } from 'lodash'

const applyMeta = (meta, routes) => {
  return routes.map((route) => {
    if (!route.meta) {
      route.meta = {}
    }

    route.meta = merge(clone(meta), route.meta)

    if (route.children) {
      route.children = applyMeta(meta, route.children)
    }

    return route
  })
}

export default applyMeta
